// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= 核心变量与重置 ================= */
:root {
    --primary-bg: #ffffff;
    --secondary-bg: #f8f9fa;
    --accent-red: #d9001b;
    --accent-red-hover: #b30015;
    --text-main: #1a1a1a;
    --text-light: #666666;
    --border-color: #eaeaea;
    --glass-bg: rgba(255, 255, 255, 0.85);
    --shadow-sm: 0 4px 12px rgba(0,0,0,0.05);
    --shadow-lg: 0 12px 32px rgba(217, 0, 27, 0.08);
    --transition-fast: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    --transition-slow: 0.6s cubic-bezier(0.22, 1, 0.36, 1);
    --font-sans:
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto,
        "Helvetica Neue",
        Arial,
        sans-serif;
    --font-sans-zh:
        "Microsoft YaHei",
        "PingFang SC",
        "Hiragino Sans GB",
        "Noto Sans SC",
        var(--font-sans);
    --font-sans-ja:
        "Yu Gothic UI",
        "Yu Gothic",
        Meiryo,
        "Hiragino Kaku Gothic ProN",
        "Noto Sans JP",
        var(--font-sans);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    font-family: var(--font-sans);
}

html:lang(zh) {
    font-family: var(--font-sans-zh);
}

html:lang(ja) {
    font-family: var(--font-sans-ja);
}

body {
    background-color: var(--primary-bg);
    color: var(--text-main);
    line-height: 1.6;
    overflow-x: hidden;
    font-family: inherit;
}

button,
input,
select,
textarea {
    font: inherit;
}

@media (min-width: 992px) {
    html {
        zoom: 0.9;
    }
}

a { text-decoration: none; color: inherit; }
ul { list-style: none; }

/* ================= 滚动动画类 ================= */
.reveal { opacity: 0; transform: translateY(40px); transition: all 0.8s cubic-bezier(0.5, 0, 0, 1); }
.reveal.active { opacity: 1; transform: translateY(0); }
.delay-1 { transition-delay: 0.1s; }
.delay-2 { transition-delay: 0.2s; }
.delay-3 { transition-delay: 0.3s; }

/* ================= 图片占位符 ================= */
.img-placeholder {
    background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
    background-size: 200% 200%;
    animation: gradientMove 3s ease infinite;
    border-radius: 8px;
    overflow: hidden;
    display: flex; align-items: center; justify-content: center; color: #999; font-size: 0.9rem;
}
@keyframes gradientMove { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }

/* ================= 通用按钮与Section样式 ================= */
.btn {
    display: inline-block; padding: 12px 32px; background: var(--accent-red); color: #fff;
    border-radius: 30px; font-weight: 600; letter-spacing: 1px; transition: var(--transition-fast);
    box-shadow: 0 8px 20px rgba(217,0,27,0.3);
}
.btn:hover { background: var(--accent-red-hover); transform: translateY(-3px); box-shadow: 0 12px 25px rgba(217,0,27,0.4); }

section { padding: 80px 0; }
.section-container { width: 90%; max-width: 1400px; margin: 0 auto; }
.section-header { margin-bottom: 50px; display: flex; flex-direction: column; align-items: flex-start; }
.section-title { font-size: 2.5rem; font-weight: 800; position: relative; display: inline-block; margin-bottom: 10px; }
.section-title::after { content: ''; position: absolute; bottom: -5px; left: 0; width: 40px; height: 3px; background: var(--accent-red); }
.section-subtitle { color: var(--text-light); font-size: 1rem; text-transform: uppercase; letter-spacing: 2px; }

html:lang(ja) .section-title {
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;IACI,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,qCAAqC;IACrC,wCAAwC;IACxC,+CAA+C;IAC/C,wDAAwD;IACxD,sDAAsD;IACtD;;;;;;;kBAOc;IACd;;;;;wBAKoB;IACpB;;;;;;wBAMoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA,IAAI,qBAAqB,EAAE,cAAc,EAAE;AAC3C,KAAK,gBAAgB,EAAE;;AAEvB,8CAA8C;AAC9C,UAAU,UAAU,EAAE,2BAA2B,EAAE,+CAA+C,EAAE;AACpG,iBAAiB,UAAU,EAAE,wBAAwB,EAAE;AACvD,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;;AAEnC,8CAA8C;AAC9C;IACI,6DAA6D;IAC7D,0BAA0B;IAC1B,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,iBAAiB;AAC/F;AACA,0BAA0B,KAAK,2BAA2B,EAAE,EAAE,MAAM,6BAA6B,EAAE,EAAE,OAAO,2BAA2B,EAAE,EAAE;;AAE3I,uDAAuD;AACvD;IACI,qBAAqB,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,WAAW;IACrF,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kCAAkC;IAC9F,yCAAyC;AAC7C;AACA,aAAa,mCAAmC,EAAE,2BAA2B,EAAE,0CAA0C,EAAE;;AAE3H,UAAU,eAAe,EAAE;AAC3B,qBAAqB,UAAU,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACpE,kBAAkB,mBAAmB,EAAE,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE;AACvG,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACtH,wBAAwB,WAAW,EAAE,kBAAkB,EAAE,YAAY,EAAE,OAAO,EAAE,WAAW,EAAE,WAAW,EAAE,6BAA6B,EAAE;AACzI,oBAAoB,wBAAwB,EAAE,eAAe,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;;AAE/G;IACI,gBAAgB;AACpB","sourcesContent":["/* ================= 核心变量与重置 ================= */\r\n:root {\n    --primary-bg: #ffffff;\n    --secondary-bg: #f8f9fa;\n    --accent-red: #d9001b;\r\n    --accent-red-hover: #b30015;\r\n    --text-main: #1a1a1a;\r\n    --text-light: #666666;\r\n    --border-color: #eaeaea;\r\n    --glass-bg: rgba(255, 255, 255, 0.85);\r\n    --shadow-sm: 0 4px 12px rgba(0,0,0,0.05);\n    --shadow-lg: 0 12px 32px rgba(217, 0, 27, 0.08);\n    --transition-fast: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n    --transition-slow: 0.6s cubic-bezier(0.22, 1, 0.36, 1);\n    --font-sans:\n        -apple-system,\n        BlinkMacSystemFont,\n        \"Segoe UI\",\n        Roboto,\n        \"Helvetica Neue\",\n        Arial,\n        sans-serif;\n    --font-sans-zh:\n        \"Microsoft YaHei\",\n        \"PingFang SC\",\n        \"Hiragino Sans GB\",\n        \"Noto Sans SC\",\n        var(--font-sans);\n    --font-sans-ja:\n        \"Yu Gothic UI\",\n        \"Yu Gothic\",\n        Meiryo,\n        \"Hiragino Kaku Gothic ProN\",\n        \"Noto Sans JP\",\n        var(--font-sans);\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    font-family: var(--font-sans);\n}\n\nhtml:lang(zh) {\n    font-family: var(--font-sans-zh);\n}\n\nhtml:lang(ja) {\n    font-family: var(--font-sans-ja);\n}\n\nbody {\n    background-color: var(--primary-bg);\n    color: var(--text-main);\n    line-height: 1.6;\n    overflow-x: hidden;\n    font-family: inherit;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n    font: inherit;\n}\n\r\n@media (min-width: 992px) {\r\n    html {\r\n        zoom: 0.9;\r\n    }\r\n}\r\n\r\na { text-decoration: none; color: inherit; }\r\nul { list-style: none; }\r\n\r\n/* ================= 滚动动画类 ================= */\r\n.reveal { opacity: 0; transform: translateY(40px); transition: all 0.8s cubic-bezier(0.5, 0, 0, 1); }\r\n.reveal.active { opacity: 1; transform: translateY(0); }\r\n.delay-1 { transition-delay: 0.1s; }\r\n.delay-2 { transition-delay: 0.2s; }\r\n.delay-3 { transition-delay: 0.3s; }\r\n\r\n/* ================= 图片占位符 ================= */\r\n.img-placeholder {\r\n    background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);\r\n    background-size: 200% 200%;\r\n    animation: gradientMove 3s ease infinite;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    display: flex; align-items: center; justify-content: center; color: #999; font-size: 0.9rem;\r\n}\r\n@keyframes gradientMove { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }\r\n\r\n/* ================= 通用按钮与Section样式 ================= */\r\n.btn {\r\n    display: inline-block; padding: 12px 32px; background: var(--accent-red); color: #fff;\r\n    border-radius: 30px; font-weight: 600; letter-spacing: 1px; transition: var(--transition-fast);\r\n    box-shadow: 0 8px 20px rgba(217,0,27,0.3);\r\n}\r\n.btn:hover { background: var(--accent-red-hover); transform: translateY(-3px); box-shadow: 0 12px 25px rgba(217,0,27,0.4); }\r\n\r\nsection { padding: 80px 0; }\r\n.section-container { width: 90%; max-width: 1400px; margin: 0 auto; }\r\n.section-header { margin-bottom: 50px; display: flex; flex-direction: column; align-items: flex-start; }\r\n.section-title { font-size: 2.5rem; font-weight: 800; position: relative; display: inline-block; margin-bottom: 10px; }\n.section-title::after { content: ''; position: absolute; bottom: -5px; left: 0; width: 40px; height: 3px; background: var(--accent-red); }\n.section-subtitle { color: var(--text-light); font-size: 1rem; text-transform: uppercase; letter-spacing: 2px; }\n\nhtml:lang(ja) .section-title {\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
